import { lazyWithRetry as lazy } from './lazyWithRetry';
import { withProtected } from './withProtected';
import { redirect } from 'react-router-dom';

export const wallet = [
	{
		path: '/wallet/',
		Component: withProtected(lazy(() => import('../pages/Wallet'))),
		handle: {
			key: 'pages.wallet.title'
		},
		children: [
			{
				path: '/wallet/',
				Component: lazy(() => import('../pages/Wallet/Categories'))
			},
			// {
			// 	path: '/student/wallet/preferences',
			// 	Component: Preferences,
			// 	handle: {
			// 		key: 'pages.student.wallet.preferences.title'
			// 	}
			// },
			{
				path: '/wallet/categories/:categoryId',
				Component: lazy(() => import('../pages/Wallet/Category')),
				handle: {
					showCategoryName: true
				}
			},
			{
				path: '/wallet/documents/',
				Component: lazy(() => import('../pages/Wallet/Documents')),
				handle: {
					key: 'pages.wallet.documents.title'
				},
				children: [
					{
						path: '/wallet/documents/',
						loader: () => redirect('/wallet/')
					},
					{
						path: '/wallet/documents/upload/:categoryId',
						Component: lazy(() => import('../pages/Wallet/Documents/Editor')),
						handle: {
							key: 'pages.wallet.documents.upload.title'
						}
					},
					{
						path: '/wallet/documents/:documentId',
						Component: lazy(() => import('../pages/Wallet/Documents/View')),
						handle: {
							showDocumentFileName: true
						}
					},
					{
						path: '/wallet/documents/:documentId/edit',
						Component: lazy(() => import('../pages/Wallet/Documents/Editor')),
						handle: {
							key: 'pages.wallet.documents.edit.title'
						}
					},
					{
						path: '/wallet/documents/:documentId/preview',
						Component: lazy(() => import('../pages/Wallet/Documents/Preview')),
						handle: {
							key: 'Preview'
						}
					}
				]
			},
			{
				path: '/wallet/shared-reports',
				Component: lazy(() => import('../pages/Wallet/SharedReports')),
				handle: {
					key: 'pages.wallet.sharedReports.title'
				}
			}
		]
	}
];
